import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { Route, Redirect } from "react-router-dom";

import withStyles from "@material-ui/core/styles/withStyles";
import Typography from "@material-ui/core/Typography";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Tab from "./Tab";

import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { Checkbox } from "@material-ui/core";
import {
  getAllActionsListRequest,
  getSelectionListRequest,
  updateSelectionRequest,
  checkAction,
  getActionsSelectedRequest
} from "../../services/action/actions";
import Colors from "../../constants/Colors";

const styles = theme => ({
  main: {
    width: "100%",
    flexDirection: "column",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  inputForm: {
    marginTop: 15,
    marginBottom: 15,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start"
  },
  inputLabel: {
    marginRight: 10,
    marginLeft: 10
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    // textOverflow: "ellipsis",
    // overflow: "hidden",
    // whiteSpace: "nowrap",
    color: Colors.text
    // maxWidth: "90%",
    // width: "90%"
  },
  title: {
    fontSize: theme.typography.pxToRem(15),
    marginBottom: 15,
    color: Colors.text
  },
  separator: {
    fontSize: theme.typography.pxToRem(15),
    marginBottom: 10,
    fontWeight: "bold",
    color: Colors.text
  },
  text: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary
  },
  table: {
    minWidth: 700
  },
  root: {
    width: "90%",
    marginTop: theme.spacing.unit * 3,
    overflowX: "auto",
    marginBottom: 15
  },
  button: {
    marginLeft: 15
  },
  actionRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center"
  },
  rowSelected: {
    backgroundColor: Colors.lightGrey
  },
  expansionDiv: {
    flex: 1
  },
  details: {
    flexDirection: "row",
    flex: 1,
    alignItems: "center",
    justifyContent: "flex-start"
  },
  checkDiv: {
    height: "100%"
    // backgroundColor: "#fff"
  },
  mainTitle: {
    fontWeight: 500,
    marginBottom: 15
  },
  saveButton: {
    backgroundColor: Colors.main
  }
});

const isNumber = n => {
  return !isNaN(parseFloat(n)) && isFinite(n);
};

class MyActionsSelected extends PureComponent {
  state = {
    expanded: null
  };

  handleChange = panel => (event, expanded) => {
    this.setState({
      expanded: expanded ? panel : false
    });
  };

  componentDidMount = () => {
    this.props.getActionsSelectedRequest({ clientId: this.props.clientId });
  };

  onChangeClient = event => {
    this.props.changeCreateField({ name: event.target.value });
  };

  onChangeEmail = event => {
    this.props.changeCreateField({ owner: event.target.value });
  };

  onChangeDomain = event => {
    this.props.changeCreateField({ domain: event.target.value });
  };

  renderActionList = actions => {
    const { classes } = this.props;
    const { expanded } = this.state;
    return actions.map((action, i) => {
      const { title, how, why, _id } = action;
      return (
        <div
          className={`${classes.actionRow} ${expanded === _id &&
            classes.rowSelected}`}
          key={i}
        >
          {/* <div className={classes.checkDiv}>
            <Typography>{i + 1}</Typography>
          </div> */}
          <div className={classes.expansionDiv}>
            <ExpansionPanel
              expanded={expanded === _id}
              onChange={this.handleChange(_id)}
            >
              <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                <p
                  className={classes.heading}
                  dangerouslySetInnerHTML={{ __html: title }}
                />
              </ExpansionPanelSummary>
              <ExpansionPanelDetails>
                <div className={classes.details}>
                  {why && <p className={classes.separator}>Pourquoi ?</p>}
                  <p
                    className={classes.title}
                    dangerouslySetInnerHTML={{ __html: why }}
                  />
                  <p className={classes.separator}>Exemples concrets</p>
                  <p
                    className={classes.title}
                    dangerouslySetInnerHTML={{ __html: how }}
                  />
                </div>
              </ExpansionPanelDetails>
            </ExpansionPanel>
          </div>
        </div>
      );
    });
  };

  render() {
    const { classes } = this.props;
    const { expanded } = this.state;
    return (
      <div className={classes.main}>
        <Paper className={classes.root}>
          {this.renderActionList(this.props.myActionsSelected)}
        </Paper>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const {
    selectionList,
    allActions,
    requesting,
    tabSelected,
    myActionsSelected
  } = state.action;
  const { clientId } = state.client;
  return {
    token: state.auth.token,
    clientId,
    selectionList,
    allActions,
    requesting,
    tabSelected,
    myActionsSelected
  };
};

export default connect(
  mapStateToProps,
  {
    getAllActionsListRequest,
    getSelectionListRequest,
    updateSelectionRequest,
    getActionsSelectedRequest,
    checkAction
  }
)(withStyles(styles)(MyActionsSelected));
